import { defineComponent, ref, computed, openBlock, createElementBlock, createBlock, resolveDynamicComponent, unref, createCommentVNode } from "vue";
import BikeMeasurements from "../../BikeMeasurements/BikeMeasurements.mjs";
import GenericMedia from "../../GenericMedia/GenericMedia2.mjs";
import GenericSizeChart from "../../GenericSizeChart/GenericSizeChart.mjs";
import SleepingBagSizeChart from "../../SleepingBagSizeChart/SleepingBagSizeChart.mjs";
const _hoisted_1 = {
  "data-ui": "size-chart-modal"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SizeChartModal",
  props: {
    bikeDiagram: {},
    isBike: {
      type: Boolean,
      default: false
    },
    showSleepingBagSizeChart: {
      type: Boolean,
      default: false
    },
    sizeChart: {
      default: null
    }
  },
  setup(__props) {
    const props = __props;
    const lazyOpts = ref({
      intersectionRatio: 1e-3,
      threshold: [0.25, 0.5, 0.75, 1]
    });
    const sizeChartToDisplay = computed(() => props.showSleepingBagSizeChart ? SleepingBagSizeChart : GenericSizeChart);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [(openBlock(), createBlock(resolveDynamicComponent(sizeChartToDisplay.value), {
        "table-data": _ctx.sizeChart
      }, null, 8, ["table-data"])), _ctx.isBike ? (openBlock(), createBlock(unref(BikeMeasurements), {
        key: 0,
        "bike-diagram": _ctx.bikeDiagram,
        modal: ""
      }, null, 8, ["bike-diagram"])) : createCommentVNode("", true), _ctx.showSleepingBagSizeChart ? (openBlock(), createBlock(unref(GenericMedia), {
        key: 1,
        class: "size-chart-modal__sleeping-bag-diagram",
        "aria-hidden": "true",
        "image-src": "https://satchel.rei.com/media/product/sleeping-bag-chart-diagram-03.jpg",
        lazy: true,
        "lazy-opts": lazyOpts.value,
        title: "sleeping bag measuring diagram",
        "data-ui": "sleeping-bag-diagram"
      }, null, 8, ["lazy-opts"])) : createCommentVNode("", true)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=SizeChartModal2.mjs.map
